import { AdSize, adSizes } from '../../components/presentational/Ad';
import theme from '../../lib/theme';
const { mediaSizes } = theme;
const {
  video,
  mobileLeaderboard,
  mediumRectangle,
  largeLeaderboard,
  halfPage,
  leaderboard,
  smallBillboard,
  mediumBillboard,
  billboard,
  fluid,
  videoDesktop,
  videoMobile,
  shortBanner,
} = adSizes;

const HIDDEN_ADHESION = process.env.HIDDEN_ADHESION;

const sponsoredInarticle: AdSize = {
  sizeMapping: [
    {
      viewport: [leaderboard[0], 0],
      slot: [mediumBillboard],
    },
    { viewport: [0, 0], slot: [mediumRectangle] },
  ],
};

const standardInarticle: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [fluid, mediumRectangle] },
    {
      viewport: [leaderboard[0], 0],
      slot: [],
    },
  ],
};

const siderail: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [] },
    { viewport: [leaderboard[0], 0], slot: [halfPage, mediumRectangle] },
  ],
};

const adhesion: AdSize = {
  sizeMapping: [
    { viewport: [0, 0], slot: [mobileLeaderboard] },
    { viewport: [mediaSizes.m, 0], slot: [leaderboard] },
  ],
};

const billboardAd: AdSize = {
  sizeMapping: [
    {
      viewport: [0, 0],
      slot: [mediumRectangle],
    },
    {
      viewport: [mediaSizes.m, 0],
      slot: [mediumRectangle, leaderboard],
    },
    {
      viewport: [mediaSizes.l, 0],
      slot: [mediumRectangle, leaderboard, billboard],
    },
  ],
};

const config: { [key: string]: AdSize } = {
  standard_billboard: billboardAd,
  standard_comments: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
    ],
  },

  standard_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_recirculation_native1: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_recirculation_native2: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_inarticle_video: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [videoMobile, video],
      },
      {
        viewport: [1024, 0],
        slot: [videoDesktop, video],
      },
    ],
  },

  standard_high_impact: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [video],
      },
    ],
  },

  sticky_recirculation_native1: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_inarticle1: standardInarticle,
  standard_inarticle2: standardInarticle,
  standard_siderail1: siderail,
  standard_siderail2: siderail,
  standard_adhesion: HIDDEN_ADHESION
    ? {
        sizeMapping: [
          {
            viewport: [0, 0],
            slot: [video],
          },
        ],
      }
    : adhesion,

  standard_scrollad: {
    sizeMapping: [
      {
        viewport: [1200, 0],
        slot: [ mediumBillboard, leaderboard, mediumRectangle ],
      },
      {
        viewport: [1024, 0],
        slot: [ mediumRectangle ],
      },
      {
        viewport: [800, 0],
        slot: [ mediumRectangle ],
      },
      {
        viewport: [0, 0],
        slot: [ video, halfPage, mediumRectangle ],
      },
    ],
  },

  sponsored_siderail1: siderail,
  sponsored_siderail2: siderail,
  sponsored_inarticle1: sponsoredInarticle,
  sponsored_inarticle2: sponsoredInarticle,
  sponsored_adhesion: adhesion,

  standard_enterprise_billboard: billboardAd,
  standard_enterprise_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  standard_enterprise_siderail_recirculation_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  sponsored_inarticle_native: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid],
      },
    ],
  },

  sponsored_inbetween: {
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [fluid, mediumRectangle],
      },
      {
        viewport: [mediaSizes.m, 0],
        slot: [fluid, mediumRectangle, mediumBillboard, leaderboard],
      },
      {
        viewport: [mediaSizes.l, 0],
        slot: [fluid, mediumRectangle, mediumBillboard, billboard],
      },
    ],
  },
};

export default config;
